import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect } from 'react';
import I18n from 'i18n-js';
import { getOfferID, isRewardOffer } from 'helper/anytime-booking';
import {
  fromUnixTime,
  formatDistance,
  differenceInCalendarDays,
  format,
} from 'date-fns';
import { OFFER_MAX_EXPIRED_DAY_DISPLAY_COUNT } from 'constants/anytime-booking-constants';
import promoIcon from 'public/icons/promo-icon.svg';
import clockIcon from 'public/icons/clock-orange.svg';
import leftArrow from 'public/icons/left-arrow-black.svg';
import cx from 'classnames';
import { connect } from 'react-redux';
import OverlayBody from '../overlay-body';
import styles from './styles.less';
import OfferPanelContext from './offer-panel-context';

const renderCountDayLeft = endUnixTime => {
  const endTime = fromUnixTime(endUnixTime);
  const expiredDateCount = differenceInCalendarDays(endTime, new Date());

  if (expiredDateCount <= OFFER_MAX_EXPIRED_DAY_DISPLAY_COUNT) {
    const countDaysLeft = formatDistance(endTime, new Date());
    return (
      <div>
        <img className={styles.infoIcon} src={clockIcon} alt="" />
        {countDaysLeft}
      </div>
    );
  }

  return (
    <div className={cx(styles.offerExpiredDate)}>
      {I18n.t('phrase.offers.marketplace_offers_offers_valid_until_label')}{' '}
      {format(endTime, 'dd MMM yyyy')}
    </div>
  );
};
const OfferTermCondition = ({
  onClose,
  onSelectOffer,
  onRemoveOffer,
  offer,
  selectedOfferID,
}) => {
  const { icon, name, description, count, offerType, endUnixTime } = offer;

  const {
    handleScribeOfferDetailDefault,
    handleScribeOfferDetailBack,
    handleScribeOfferDetailUseOffer,
  } = useContext(OfferPanelContext);
  const offerID = getOfferID(offer);
  const isOfferSelected = offerID === selectedOfferID;
  const isReward = isRewardOffer(offerType);

  useEffect(
    () => {
      handleScribeOfferDetailDefault({ offerID: offer.offerID });
    },
    [handleScribeOfferDetailDefault, offer],
  );

  const onCloseOfferTermCondition = useCallback(
    () => {
      handleScribeOfferDetailBack({ offerID: offer.offerID });
      onClose();
    },
    [handleScribeOfferDetailBack, offer, onClose],
  );

  const onConfirmClick = useCallback(
    () => {
      if (isOfferSelected) {
        onRemoveOffer();
      } else {
        onSelectOffer();
        handleScribeOfferDetailUseOffer();
      }
    },
    [isOfferSelected, handleScribeOfferDetailUseOffer],
  );

  return (
    <OverlayBody
      title={I18n.t(
        'phrase.offers.mktplace_offers_button_offer_details_edge_case',
      )}
      showHeader
      showTitle
      onClose={onCloseOfferTermCondition}
      showFooter
      showConfirm
      customHeaderIcon={leftArrow}
      confirmButtonText={
        isOfferSelected
          ? I18n.t('phrase.offers.marketplace_offers_offers_use_later')
          : I18n.t('phrase.offers.marketplace_offers_offers_use_now')
      }
      onConfirmClick={onConfirmClick}
      classnames={{
        confirmButton: isOfferSelected ? styles.useLater : styles.confirmButton,
      }}
    >
      <div className={styles.promoListContainer}>
        <div className={styles.offerHeader}>
          <img className={styles.offerDetailIcon} src={icon} alt="" />

          <div className={styles.offerDetailInfo}>
            <div className={styles.offerDetailContentName}>{name}</div>
            <div className={cx(styles.offerCount, styles.offerInfoColor)}>
              {isReward ? (
                <div className={styles.offerInfo}>
                  <img className={styles.infoIcon} src={promoIcon} alt="" />
                  {count}
                </div>
              ) : null}
              {renderCountDayLeft(endUnixTime)}
            </div>
          </div>
        </div>
        <div
          className={styles.offerDetailDescription}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </OverlayBody>
  );
};

OfferTermCondition.propTypes = {
  offer: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func,
  selectedOfferID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelectOffer: PropTypes.func,
  onRemoveOffer: PropTypes.func,
};

OfferTermCondition.defaultProps = {
  onClose: undefined,
  onSelectOffer: undefined,
  onRemoveOffer: undefined,
  selectedOfferID: undefined,
};

export default connect()(OfferTermCondition);
